export default "__VITE_ASSET__06fdf9cb__"